package de.oevbs.kunde.kundenportal2.navigation.components

import de.oevbs.kosmos.ui.icons.MaterialIconsFilled
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.activePage
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.hasAuthority
import de.oevbs.kunde.kundenportal2.children
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.path
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.theRouter
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses
import kotlinx.coroutines.flow.combine

class Navbar {

    private fun RenderContext.navigationButton(page: Page, active: Boolean = false, submenu: Boolean = false) {
        button(
            joinClasses(
                "w-full py-1 pr-4 flex flex-row justify-between items-center font-semibold",
                if (submenu) "pl-8 bg-primary-300" else "pl-4 bg-primary-500",
                "hover:bg-primary-100 hover:text-gray-950",
            )
        ) {
            +page.linkTitle

            if (active) {
                icon("w-5 h-5", icon = MaterialIconsFilled.double_arrow)
            }
        }.clicks handledBy {
            page.visit()
        }
    }

    fun RenderContext.render() {
        nav("bg-primary-700 text-white leading-relaxed") {
            ul("space-y-1") {
                combine(
                    PortalSession.data,
                    theRouter.activePage,
                    ::Pair
                ).render(into = this) { (principal, activePage) ->
                    Pages.root.children.filter(Page::showInMenu).forEach { topLevelPage ->
                        val pathOfActivePage = activePage?.path ?: emptyList()

                        if (hasAuthority(principal, topLevelPage.roleForMenu)) {
                            li {
                                navigationButton(topLevelPage)
                            }

                            topLevelPage.children.forEach { child ->
                                li(joinClasses(
                                    "hidden".takeUnless {
                                        topLevelPage in pathOfActivePage && hasAuthority(principal, child.roleForMenu)
                                    }
                                )) {
                                    navigationButton(child, active = child in pathOfActivePage, submenu = true)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Rendert eine vertikale Navigationsleiste, die ihren Inhalt
 * dynamisch aus dem [Pages]-Objekt generiert.
 */
fun RenderContext.navbar() {
    Navbar().run { render() }
}